const makeConstant = (constant) => `profile/${constant}`

export const SET_JOB_TITLE = makeConstant('SET_JOB_TITLE')
export const SET_COMPANY_NAME = makeConstant('SET_COMPANY_NAME')
export const SET_COMPANY_URL = makeConstant('SET_COMPANY_URL')
export const SET_HANDLE = makeConstant('SET_HANDLE')

export const CHECK_UNIQUE_HANDLE = makeConstant('CHECK_UNIQUE_HANDLE')
export const CHECK_UNIQUE_HANDLE_SUCCESS = makeConstant(
  'CHECK_UNIQUE_HANDLE_SUCCESS'
)
export const CHECK_UNIQUE_HANDLE_FAILED = makeConstant(
  'CHECK_UNIQUE_HANDLE_FAILED'
)

export const CREATE_PROFILE = makeConstant('CREATE_PROFILE')
export const CREATE_PROFILE_SUCCESS = makeConstant('CREATE_PROFILE_SUCCESS')
export const CREATE_PROFILE_PENDING = makeConstant('CREATE_PROFILE_PENDING')
export const CREATE_PROFILE_FAILED = makeConstant('CREATE_PROFILE_FAILED')

export const UPDATE_PROFILE = makeConstant('UPDATE_PROFILE')
export const UPDATE_PROFILE_SUCCESS = makeConstant('UPDATE_PROFILE_SUCCESS')
export const UPDATE_PROFILE_PENDING = makeConstant('UPDATE_PROFILE_PENDING')
export const UPDATE_PROFILE_FAILED = makeConstant('UPDATE_PROFILE_FAILED')

export const FETCH_PROFILE = makeConstant('FETCH_PROFILE')
export const FETCH_PROFILE_SUCCESS = makeConstant('FETCH_PROFILE_SUCCESS')
export const FETCH_PROFILE_PENDING = makeConstant('FETCH_PROFILE_PENDING')
export const FETCH_PROFILE_FAILED = makeConstant('FETCH_PROFILE_FAILED')

export const UPLOAD_COVER_PHOTO = makeConstant('UPLOAD_COVER_PHOTO')
export const UPLOAD_COVER_PHOTO_SUCCESS = makeConstant(
  'UPLOAD_COVER_PHOTO_SUCCESS'
)
export const UPLOAD_COVER_PHOTO_PENDING = makeConstant(
  'UPLOAD_COVER_PHOTO_PENDING'
)
export const UPLOAD_COVER_PHOTO_FAILED = makeConstant(
  'UPLOAD_COVER_PHOTO_FAILED'
)
